import { Client, Controller, Endpoint, mapUrl } from "@/repository";

export const ringingFilePathQueryKey = "ringingFilePath";

export const getRingingFilePath = (isSimoultaneousOffering: boolean): Promise<string> => {
	return Client.instance.get<string>(
		mapUrl(Controller.Media, Endpoint.RingingFile), {
		isSimoultaneousOffering: isSimoultaneousOffering
	});
};
